// components/ClearAllToastsButton.tsx
import React from "react";
import { toast, useSonner } from "sonner";
import styled from "styled-components";

const ClearButton = styled.button`
    position: absolute;
    right: 16px;
    z-index: 999999;

    background: none;
    color: black;
    border: none;
    border-radius: 6px;
    padding: 6px 12px;
    font-size: 13px;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.2s ease;
    pointer-events: none;
    &.visible {
        opacity: 1;
        pointer-events: auto;
    }

    &:hover {
        font-weight: bold;
    }
`;

export const ClearAllToastsButton: React.FC = () => {
    const { toasts } = useSonner();
    function removeAllToasts() {
        toasts.forEach((t) => toast.dismiss(t.id));
    }
    // Показывать только если тостов > 3
    if (toasts.length <= 3) return null;

    return (
        <ClearButton className="visible" onClick={removeAllToasts}>
            Закрыть все
        </ClearButton>
    );
};
